import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve an image src: absolute URLs and data URLs pass through;
// backend-relative paths (e.g. "/api/static/...") get the backend origin prefixed.
export const assetUrl = (src) => {
  if (!src) return src;
  if (src.startsWith("http") || src.startsWith("data:")) return src;
  if (src.startsWith("/")) return `${BACKEND_URL}${src}`;
  return src;
};

export const getGallery = () => axios.get(`${API}/gallery`).then((r) => r.data);

export const addGalleryItem = (payload, passcode) =>
  axios.post(`${API}/gallery`, payload, { headers: { "X-Admin-Passcode": passcode } }).then((r) => r.data);

export const deleteGalleryItem = (id, passcode) =>
  axios.delete(`${API}/gallery/${id}`, { headers: { "X-Admin-Passcode": passcode } }).then((r) => r.data);

export const verifyPasscode = (passcode) =>
  axios.post(`${API}/admin/verify`, { passcode }).then((r) => r.data.ok);

export const createInquiry = (payload) =>
  axios.post(`${API}/inquiries`, payload).then((r) => r.data);

export const visualize = (payload) =>
  axios.post(`${API}/visualize`, payload, { timeout: 120000 }).then((r) => r.data);
